import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { loadShadowProject } from './thunks/loadShadowProject.thunk';
import { loadShadowRecordForRecord } from './thunks/loadShadowRecordForRecord.thunk';
import { loadShadowRecordsForRecords } from './thunks/loadShadowRecordsForRecords.thunk';
import { updateShadowProjectThunk } from './thunks/updateShadowProject.thunk';
import { updateShadowRecordAssignment } from './thunks/updateShadowRecordAssignment.thunk';

const shadowProjectsAdapter = createEntityAdapter();
const shadowRecordsAdapter = createEntityAdapter();

export const shadowDataSlice = createSlice({
  name: 'shadowData',
  initialState: {
    shadowProjects: shadowProjectsAdapter.getInitialState(),
    isLoadingShadowProject: false,
    shadowRecords: shadowRecordsAdapter.getInitialState(),
    isLoadingShadowRecords: false,
    isUpdatingShadowRecord: false,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(loadShadowProject.pending, (state) => {
        state.isLoadingShadowProject = true;
      })
      .addCase(loadShadowProject.fulfilled, (state, action) => {
        state.isLoadingShadowProject = false;
        if (action.payload) {
          shadowProjectsAdapter.upsertOne(state.shadowProjects, action.payload);
        }
      })
      .addCase(loadShadowProject.rejected, (state) => {
        state.isLoadingShadowProject = false;
      })
      .addCase(updateShadowProjectThunk.fulfilled, (state, action) => {
        if (action.payload) {
          shadowProjectsAdapter.upsertOne(state.shadowProjects, action.payload);
        }
      })
      .addCase(loadShadowRecordForRecord.pending, (state) => {
        state.isLoadingShadowRecords = true;
      })
      .addCase(loadShadowRecordForRecord.fulfilled, (state, action) => {
        state.isLoadingShadowRecords = false;
        if (action.payload) {
          shadowRecordsAdapter.upsertMany(state.shadowRecords, action.payload);
        }
      })
      .addCase(loadShadowRecordForRecord.rejected, (state) => {
        state.isLoadingShadowRecords = false;
      })
      .addCase(loadShadowRecordsForRecords.pending, (state) => {
        state.isLoadingShadowRecords = true;
      })
      .addCase(loadShadowRecordsForRecords.fulfilled, (state, action) => {
        state.isLoadingShadowRecords = false;
        if (action.payload) {
          shadowRecordsAdapter.upsertMany(state.shadowRecords, action.payload);
        }
      })
      .addCase(loadShadowRecordsForRecords.rejected, (state) => {
        state.isLoadingShadowRecords = false;
      })
      .addCase(updateShadowRecordAssignment.pending, (state) => {
        state.isUpdatingShadowRecord = true;
      })
      .addCase(updateShadowRecordAssignment.fulfilled, (state, action) => {
        state.isUpdatingShadowRecord = false;
        if (action.payload) {
          shadowRecordsAdapter.upsertOne(state.shadowRecords, action.payload);
        }
      })
      .addCase(updateShadowRecordAssignment.rejected, (state) => {
        state.isUpdatingShadowRecord = false;
      });
  },
});

export default shadowDataSlice;
